<app-orders-table
  [dataSource]="dataSource"
  [orderState]="OrderStateEnum.FinalFailed"
  [warehouses]="warehouses"
  [businesses]="businesses"
  [displayedColumns]="displayedColumns"
  (tableActionTaken)="handleTableAction($event)"
></app-orders-table>